import logo from './logo.svg';
import './App.css';
import {useSelector, UseDispatch} from 'react-redux';
import {userData, transactionData} from './redux/slices/userSlice';
import { useState } from 'react';
import {login} from './api/api';
import {BrowserRouter, Routes, Route} from 'react-router-dom';
import Login from './pages/Login';
import AddUser from './pages/addUser';
import Dashboard from './pages/dashboard';
import Payment from './pages/payment';
import SuccessfulTransaction from './pages/transactions/successful';
import FailedTransaction from './pages/transactions/failed';
// import './css/style.css';
import SiderBarPro from './components/siderBarPro';
import Users from './pages/user';
import Nav from './pages/home';
import CreateUser from './pages/newUser';
import AddStoreItem from './pages/addStoreItem';


function App() {
  const data = useSelector(state => state.user);


const trans = transactionData({
  email: 'uselite4199@gmail.com',
});
 
  
  return (
    <>
    <BrowserRouter>
      <Routes>
          <Route path='/' element={<Login/>}/> 
          <Route element={<Nav/>} >
              <Route path='/dashboard' element={<Dashboard />}/> 
              
              {/* <Route path='users' element={<Users/>}/>  */}
              <Route path='/addUser' element={<AddUser/>}/> 
              <Route path='/users' element={<Users/>}/> 
                <Route path='/transaction' element={<SuccessfulTransaction/>}/>
                <Route path='/ftransaction' element={<FailedTransaction/>}/> 
              <Route path='/payment' element={<Payment/>}/>
              <Route path='/new-user' element={<CreateUser/>}/>
              <Route path='/add_store_item' element={<AddStoreItem />} />
              <Route path='*' element={<div><h2> 404 </h2>
                <h3> PAGE NOT FOUND </h3>
              </div>} />
          </Route>

      </Routes>
    </BrowserRouter>
    </>
  );
}

export default App;
